<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Date">
      <b-form-checkbox @input="changeProp" v-model="field.params.input_date" />
    </b-form-group>
    <b-form-group label-cols="3" label="Time">
      <b-form-checkbox @input="changeProp" v-model="field.params.input_time" />
    </b-form-group>
    <b-form-group label-cols="3" label="Placeholder">
      <b-form-input @change="changeProp" v-model="field.params.placeholder" />
    </b-form-group>
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input @change="changeProp" v-model="field.params.tooltip" />
    </b-form-group>

    <!-- Default Settings -->
    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label="Default Value"
      label-cols="3"
      v-if="field.default_option"
    >
      <b-form-select @change="changeProp" v-model="field.default_value">
        <option value="now">Now</option>
        <option :value="null">Blank</option>
      </b-form-select>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "DatetimeProps",
  components: { WidgetCommonProps },
  mixins: [WidgetPropMixin],
};
</script>
